/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketspayoutsunfinished2Inputs */

const en_ticketspayoutsunfinished2 = /** @type {(inputs: Ticketspayoutsunfinished2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stripe still needs a few details before paid tickets can be bought.`)
};

const de_ticketspayoutsunfinished2 = /** @type {(inputs: Ticketspayoutsunfinished2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stripe braucht noch ein paar Angaben, bevor bezahlte Tickets buchbar sind.`)
};

/**
* | output |
* | --- |
* | "Stripe still needs a few details before paid tickets can be bought." |
*
* @param {Ticketspayoutsunfinished2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketspayoutsunfinished2 = /** @type {((inputs?: Ticketspayoutsunfinished2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketspayoutsunfinished2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketspayoutsunfinished2(inputs)
	return de_ticketspayoutsunfinished2(inputs)
});
export { ticketspayoutsunfinished2 as "ticketsPayoutsUnfinished" }